import { fmtDateTime } from "@/lib/finance";
import { CaptureMedia } from "@/components/conecta/CaptureMedia";

const show = (v) => (v == null || v === "" ? "Sin definir" : String(v));

export const Timeline = ({ events, labels }) => (
  <ol data-testid="immutable-timeline-container" className="relative border-l c-line ml-2 space-y-4">
    {events.map((ev) => (
      <li key={ev.id} data-testid="timeline-event" className="ml-4">
        <span className="absolute -left-[5px] mt-1.5 w-2.5 h-2.5 rounded-full bg-[#bc9538]" />
        <p className="text-sm font-semibold">{ev.summary}</p>
        <p className="text-[11px] c-muted">{fmtDateTime(ev.created_at)} · {ev.user_name || "—"}</p>
        {ev.capture_id && (
          <div data-testid="timeline-capture" className="mt-1.5 space-y-1.5">
            <CaptureMedia captureId={ev.capture_id} kind={ev.media_kind} testid="timeline-capture-media" />
            {ev.transcription && (
              <details className="text-xs c-text-2"><summary className="cursor-pointer c-accent">Transcripción</summary><p data-testid="timeline-transcription" className="mt-1 whitespace-pre-wrap">{ev.transcription}</p></details>
            )}
          </div>
        )}
        {ev.event_type === "editado" && (
          <ul className="mt-1 space-y-0.5">
            {ev.changes.map((c) => (
              <li key={c.field} className="text-xs c-text-2"><b>{labels[c.field] || c.field}:</b> {show(c.from)} → {show(c.to)}</li>
            ))}
          </ul>
        )}
      </li>
    ))}
  </ol>
);
